<template>
  <div>
    <v-card tile>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-chip label color="transparent" text-color="black">
                <h3>Nuevo Consumo</h3>
              </v-chip>
            </v-col>
          </v-row>

          <!-- Toggle modo producto -->
          <v-row class="mt-0 mb-1">
            <v-col cols="12">
              <v-switch
                v-model="modoProducto"
                label="Cargar producto del catálogo"
                inset
                dense
                hide-details
                color="primary"
              ></v-switch>
            </v-col>
          </v-row>

          <!-- Botón cargar turno (solo cuando el tipo de turno tiene precio) -->
          <v-row v-if="tipoTurno && tipoTurno.total" class="mt-0 mb-2">
            <v-col cols="12">
              <v-btn small color="indigo" dark @click="precargarTurno">
                <v-icon left small>mdi-tennis-ball</v-icon>
                Cargar turno ({{ tipoTurno.nombre }} — ${{
                  tipoTurno.total
                }}/jugador)
              </v-btn>
            </v-col>
          </v-row>

          <!-- Selector de grupo (solo en contexto torneo/libre) -->
          <v-row v-if="idTorneo > 0 || fechaLibre != null" class="mt-0 mb-1">
            <v-col cols="12" sm="6">
              <v-select
                v-model="grupoSeleccionado"
                :items="opcionesGrupo"
                item-text="nombre"
                item-value="idGrupo"
                label="Asignar a mesa/grupo (opcional)"
                prepend-icon="mdi-table-chair"
                dense
                clearable
                no-data-text="No hay grupos creados"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex align-center">
              <v-btn small color="teal" dark @click="abrirNuevoGrupo">
                <v-icon left small>mdi-plus</v-icon>
                Nueva mesa/grupo
              </v-btn>
            </v-col>
          </v-row>

          <!-- Bloque modo producto -->
          <v-row v-show="modoProducto" class="mt-2">
            <v-col cols="12">
              <v-alert v-if="errorCargaProductos" type="error" dense>
                No se pudo cargar el catálogo de productos. Intente nuevamente.
              </v-alert>
              <v-autocomplete
                v-model="productoSeleccionado"
                :items="catalogoProductos"
                :loading="cargandoProductos"
                item-text="nombre"
                item-value="idProducto"
                return-object
                prepend-icon="mdi-package-variant"
                label="Producto *"
                dense
                clearable
                no-data-text="No hay productos activos disponibles"
                :filter="
                  (item, queryText) =>
                    item.nombre
                      .toLowerCase()
                      .includes(queryText.toLowerCase()) ||
                    (item.codigo &&
                      item.codigo
                        .toLowerCase()
                        .includes(queryText.toLowerCase()))
                "
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.codigo"
                      >Código: {{ item.codigo }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                v-model.number="cantidad"
                prepend-icon="mdi-counter"
                label="Cantidad *"
                type="number"
                min="1"
                dense
                @keypress="onlyNumber"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                v-model="precioUnitario"
                prepend-icon="mdi-currency-usd"
                label="Precio unitario *"
                dense
                @keypress="onlyNumber"
                @blur="toFixedPrecio"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                :value="totalCalculado"
                prepend-icon="mdi-calculator"
                label="Total"
                dense
                disabled
                prefix="$"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mt-2">
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="fechaConsumo"
                :value="fechaConsumo"
                label="Fecha Consumo *"
                :rules="requiredRules"
                prepend-icon="mdi-calendar"
                type="date"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-show="!modoProducto">
            <v-col cols="12">
              <v-text-field
                v-model="descripcion"
                prepend-icon="mdi-account"
                :label="
                  fechaLibre != null
                    ? 'Descripción (ej: Nombre del cliente) *'
                    : idTorneo > 0
                    ? 'Descripción *'
                    : 'Descripcion'
                "
                :rules="
                  (idTorneo > 0 || fechaLibre != null) && !modoProducto
                    ? requiredRules
                    : []
                "
                dense
                maxlength="200"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-show="!modoProducto">
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="total"
                prepend-icon="mdi-currency-usd"
                :rules="modoProducto ? [] : totalRules"
                label="Importe *"
                @blur="toFixed"
                @keypress="onlyNumber"
                dense
                maxlength="10"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="observaciones"
                prepend-icon="mdi-account"
                label="Observaciones"
                dense
                maxlength="200"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :disabled="
              !valid ||
              (modoProducto && (!productoSeleccionado || cantidad <= 0))
            "
            @click.stop="guardarConsumo"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-form>

      <!-- Dialog para crear nuevo grupo (fuera del form para evitar conflictos) -->
      <v-dialog v-model="showNuevoGrupo" max-width="400px" persistent>
        <v-card class="mb-0">
          <v-card-title>Nueva mesa / grupo</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="nuevoNombreGrupo"
              label="Nombre (ej: Mesa 3, Equipo Rojo)"
              autofocus
              @keyup.enter="confirmarNuevoGrupo"
              dense
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="showNuevoGrupo = false">Cancelar</v-btn>
            <v-btn
              color="teal"
              dark
              :disabled="!nuevoNombreGrupo"
              @click="confirmarNuevoGrupo"
              >Crear</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card-text
        v-if="
          idTurno > 0 || idInscripcion > 0 || idTorneo > 0 || fechaLibre != null
        "
      >
        <v-row dense>
          <v-col cols="12" style="margin-top: 3px">
            <v-chip class="ma-0" label color="transparent" text-color="black">
              <h3>
                {{
                  fechaLibre != null
                    ? "Consumos ya realizados para este día"
                    : "Consumos ya realizados para este " +
                      (idTorneo > 0
                        ? "competencia"
                        : idTurno > 0
                        ? "turno"
                        : "jugador")
                }}
              </h3>
            </v-chip>
          </v-col>
        </v-row>

        <!-- Grupos (mesas) -->
        <div v-if="grupos.length > 0" class="mb-4">
          <v-subheader class="pl-0 font-weight-bold"
            >Mesas / Grupos</v-subheader
          >
          <v-expansion-panels accordion>
            <v-expansion-panel
              v-for="grupo in grupos"
              :key="grupo.idGrupo"
              class="grupo-panel"
            >
              <v-expansion-panel-header>
                <div
                  class="d-flex align-center justify-space-between"
                  style="width: 100%"
                >
                  <span class="font-weight-bold">
                    <v-icon small class="mr-1">mdi-table-chair</v-icon>
                    {{ grupo.nombreGrupo }}
                  </span>
                  <div class="d-flex align-center mr-4" style="gap: 12px">
                    <span class="caption"
                      >Consumido:
                      <strong
                        >${{ grupo.totalConsumido.toFixed(2) }}</strong
                      ></span
                    >
                    <span class="caption"
                      >Pagado:
                      <strong
                        >${{ grupo.totalCobrado.toFixed(2) }}</strong
                      ></span
                    >
                    <v-chip
                      x-small
                      :color="grupo.saldo > 0 ? 'error' : 'success'"
                      dark
                    >
                      Saldo: ${{ grupo.saldo.toFixed(2) }}
                    </v-chip>
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <!-- Consumos del grupo -->
                <v-simple-table dense class="mb-3">
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Descripción</th>
                      <th>Observaciones</th>
                      <th>Importe</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="c in grupo.consumos" :key="c.idConsumo">
                      <td>{{ c.fechaString }}</td>
                      <td>{{ c.observaciones }}</td>
                      <td>{{ c.totalString }}</td>
                      <td>
                        <v-icon small color="red" @click="borrarConsumo(c)"
                          >mdi-delete</v-icon
                        >
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <!-- Cobros del grupo -->
                <div v-if="cobrosGrupo[grupo.idGrupo]">
                  <v-subheader class="pl-0 caption"
                    >Cobros del grupo</v-subheader
                  >
                  <v-simple-table
                    dense
                    v-if="cobrosGrupo[grupo.idGrupo].length"
                  >
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th>Forma Pago</th>
                        <th>Estado</th>
                        <th>Importe</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="cobro in cobrosGrupo[grupo.idGrupo]"
                        :key="cobro.idCobro"
                      >
                        <td>{{ cobro.fechaString }}</td>
                        <td>{{ cobro.nombreFormaPago }}</td>
                        <td>
                          <v-chip
                            x-small
                            :color="
                              cobro.estado === 'Aprobado'
                                ? 'blue'
                                : cobro.estado === 'Pendiente'
                                ? 'red'
                                : 'orange'
                            "
                            dark
                          >
                            {{ cobro.estado }}
                          </v-chip>
                        </td>
                        <td>{{ cobro.totalString }}</td>
                        <td>
                          <v-icon
                            small
                            color="red"
                            @click="borrarCobroGrupo(cobro, grupo.idGrupo)"
                            >mdi-delete</v-icon
                          >
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <v-alert v-else color="grey" outlined dense class="ma-0 mt-1"
                    >Sin cobros registrados para este grupo.</v-alert
                  >
                </div>
                <!-- Acciones del grupo -->
                <div class="d-flex mt-3" style="gap: 8px">
                  <v-btn small color="success" @click="cobrarGrupo(grupo)">
                    <v-icon left small>mdi-cash</v-icon>
                    Cobrar grupo
                  </v-btn>
                  <v-btn
                    v-if="grupo.saldo > 0"
                    small
                    color="indigo"
                    dark
                    @click="abrirEnviarCtaCteGrupo(grupo)"
                  >
                    <v-icon left small>mdi-bank-transfer</v-icon>
                    Enviar a Cta Cte
                  </v-btn>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>

        <!-- Consumos sueltos (sin grupo) -->
        <v-subheader v-if="grupos.length > 0" class="pl-0 font-weight-bold"
          >Consumos sueltos</v-subheader
        >

        <v-alert
          v-if="grupos.length > 0 && consumosSueltos.length === 0"
          color="grey"
          outlined
          dense
          class="mb-3"
        >
          No hay consumos sueltos para
          {{ fechaLibre != null ? "este día" : "esta competencia" }}.
        </v-alert>

        <v-data-table
          v-if="listaConsumos.length && consumosSueltos.length"
          :headers="
            idTorneo > 0 || fechaLibre != null ? headersTorneo : headers
          "
          :items="consumosSueltos"
          class="elevation-1"
          :hide-default-footer="true"
          locale="es-ar"
          item-key="idConsumo"
          :items-per-page="10000"
          ref="myTable"
          :disable-sort="true"
          :show-expand="idTorneo > 0 || fechaLibre != null"
          :expanded.sync="expandedItems"
          @item-expanded="onRowExpanded($event.item)"
          @click:row="clickRow"
          :no-data-text="
            fechaLibre != null
              ? 'No hay consumos sueltos para este día'
              : idTorneo > 0
              ? 'No hay consumos sueltos para este torneo'
              : 'No hay consumos'
          "
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-0 expanded-detail-cell">
              <div class="expanded-detail-container">
                <!-- Indicador visual de que es detalle del consumo de arriba -->
                <div class="expanded-detail-header">
                  <v-icon small class="mr-1" color="indigo"
                    >mdi-receipt-text</v-icon
                  >
                  <span class="caption font-weight-bold indigo--text">
                    Cobros del consumo:
                    {{ item.descripcion || item.totalString }}
                  </span>
                </div>
                <div
                  v-if="cobrosExpandidos[item.idConsumo] === undefined"
                  class="text-center py-2"
                >
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    size="20"
                  ></v-progress-circular>
                </div>
                <div v-else-if="cobrosExpandidos[item.idConsumo].length === 0">
                  <v-alert
                    color="purple"
                    dark
                    outlined
                    dense
                    class="ma-0 mx-3 mb-2"
                  >
                    No hay cobros registrados para este consumo.
                  </v-alert>
                </div>
                <div v-else class="px-3 pb-2">
                  <v-simple-table dense class="cobros-detalle-table">
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th>Concepto</th>
                        <th>Forma Pago</th>
                        <th>Estado</th>
                        <th>Importe</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="cobro in cobrosExpandidos[item.idConsumo]"
                        :key="cobro.idCobro"
                      >
                        <td>{{ cobro.fechaString }}</td>
                        <td>{{ cobro.paciente }}</td>
                        <td>{{ cobro.nombreFormaPago }}</td>
                        <td>
                          <v-chip
                            x-small
                            :color="
                              cobro.estado === 'Aprobado'
                                ? 'blue'
                                : cobro.estado === 'Pendiente'
                                ? 'red'
                                : 'orange'
                            "
                            dark
                          >
                            {{ cobro.estado }}
                          </v-chip>
                        </td>
                        <td>{{ cobro.totalString }}</td>
                        <td>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                small
                                color="red"
                                v-on="on"
                                v-bind="attrs"
                                @click="
                                  borrarCobroDetalle(cobro, item.idConsumo)
                                "
                                >mdi-delete</v-icon
                              >
                            </template>
                            <span>Eliminar cobro</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </div>
              </div>
            </td>
          </template>
          <template v-slot:item.descripcion="{ item }">
            <span v-if="item.idProducto && item.cantidad">
              {{ item.descripcion }} — {{ item.cantidad }} x ${{
                (item.total / item.cantidad).toFixed(2)
              }}
              = {{ item.totalString }}
            </span>
            <span v-else>{{ item.descripcion }}</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  color="purple"
                  class="mr-3"
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="editarConsumo(item)"
                  >mdi-pencil</v-icon
                >
              </template>
              <span>Editar consumo</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  v-on="on"
                  class="mr-3"
                  color="red"
                  v-bind="attrs"
                  @click.stop="borrarConsumo(item)"
                  >mdi-delete</v-icon
                >
              </template>
              <span>Eliminar consumo</span>
            </v-tooltip>
            <!-- Botón Enviar a Cta Cte por consumo (torneo y contexto libre) -->
            <v-tooltip
              v-if="
                (idTorneo > 0 || fechaLibre != null) && calcularSaldo(item) > 0
              "
              top
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  v-on="on"
                  v-bind="attrs"
                  color="indigo"
                  @click.stop="abrirEnviarCtaCteConsumo(item)"
                  >mdi-bank-transfer</v-icon
                >
              </template>
              <span>Enviar saldo a Cuenta Corriente</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-alert
          class="mt-4"
          color="purple"
          dark
          outlined
          v-if="!listaConsumos.length"
        >
          No hay consumos realizados para
          {{
            fechaLibre != null
              ? "este día"
              : idTorneo > 0
              ? "esta competencia"
              : idTurno > 0
              ? "este turno"
              : "este jugador"
          }}.
        </v-alert>
        <v-row v-if="listaConsumos.length" class="mt-2">
          <v-col cols="12" class="d-flex" style="gap: 8px; flex-wrap: wrap">
            <v-btn color="primary" @click="exportarPDFNuevo">
              <v-icon left>mdi-file-pdf-box</v-icon>
              Exportar a PDF
            </v-btn>
            <v-btn
              v-if="grupos.length > 0"
              color="teal darken-1"
              dark
              @click="exportarPDFPorGrupo"
            >
              <v-icon left>mdi-file-pdf-box</v-icon>
              PDF por Mesa
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <EditarConsumo
        :visible="showEditarConsumo"
        :idConsumo="editedItem.idConsumo"
        @close="cierraEditarConsumo($event)"
      ></EditarConsumo>
      <EnviarACuentaCorriente
        v-if="consumoParaCtaCte"
        :visible="showEnviarCtaCteConsumo"
        :saldoDisponible="calcularSaldo(consumoParaCtaCte)"
        :idTurno="idTurno"
        :idInscripcion="idInscripcion"
        :idConsumo="consumoParaCtaCte.idConsumo"
        @close="cierraEnviarCtaCteConsumo"
        @enviado="cierraEnviarCtaCteConsumo"
      ></EnviarACuentaCorriente>
      <EnviarACuentaCorriente
        v-if="grupoParaCtaCte"
        :visible="showEnviarCtaCteGrupo"
        :saldoDisponible="grupoParaCtaCte.saldo"
        :idTurno="idTurno"
        :idInscripcion="idInscripcion"
        :idGrupo="grupoParaCtaCte.idGrupo"
        @close="cierraEnviarCtaCteGrupo"
        @enviado="cierraEnviarCtaCteGrupo"
      ></EnviarACuentaCorriente>
    </v-card>
  </div>
</template>
<script>
import moment from "moment";
import axios from "@/axios-auth";
import { showAlert } from "@/utils/toast";
import EditarConsumo from "./EditarConsumo.vue";
import EnviarACuentaCorriente from "./EnviarACuentaCorriente.vue";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  props: {
    idTurno: {
      required: false,
      default: 0,
    },
    idInscripcion: {
      required: false,
      default: 0,
    },
    idTorneo: {
      required: false,
      default: 0,
    },
    nombrePaciente: {
      type: String,
      required: false,
      default: "",
    },
    cantJugadores: {
      required: false,
      default: 1,
    },
    listaCobros: {
      type: Array,
      required: false,
      default: () => [],
    },
    tipoTurno: {
      type: Object,
      required: false,
      default: null,
    },
    fechaLibre: {
      type: String,
      default: null,
    },
    fechaTurno: {
      type: String,
      default: null,
    },
  },
  components: {
    EditarConsumo,
    EnviarACuentaCorriente,
  },
  data() {
    return {
      valid: false,
      lazy: false,
      fechaConsumo: null,
      descripcion: "",
      observaciones: "",
      total: null,
      requiredRules: [(v) => !!v || "Dato obligatorio"],
      totalRules: [
        (v) => !!v || "Dato obligatorio",
        (v) => v > 0 || "El total debe ser mayor a 0",
      ],
      listaConsumos: [],
      headers: [
        { text: "Fecha", value: "fechaString" },
        { text: "Descripción", value: "descripcion" },
        { text: "Observaciones", value: "observaciones" },
        { text: "Importe", value: "totalString" },
        { text: "Acciones", value: "actions" },
      ],
      showEditarConsumo: false,
      editedItem: {},
      cobrosExpandidos: {},
      expandedItems: [],
      showEnviarCtaCteConsumo: false,
      consumoParaCtaCte: null,
      // Grupos
      grupoSeleccionado: null,
      showNuevoGrupo: false,
      nuevoNombreGrupo: "",
      gruposLocales: [], // grupos creados en esta sesión (idGrupo temporal + nombre)
      cobrosGrupo: {}, // { idGrupo: [cobros] }
      showEnviarCtaCteGrupo: false,
      grupoParaCtaCte: null,
      headersTorneo: [
        { text: "Fecha", value: "fechaString" },
        { text: "Descripción", value: "descripcion" },
        { text: "Observaciones", value: "observaciones" },
        { text: "Total Consumo", value: "totalString" },
        { text: "Total Pagado", value: "totalPagadoString" },
        { text: "Saldo", value: "saldoString" },
        { text: "Acciones", value: "actions" },
      ],
      // Modo producto
      modoProducto: true,
      productoSeleccionado: null,
      catalogoProductos: [],
      cargandoProductos: false,
      errorCargaProductos: false,
      cantidad: 1,
      precioUnitario: null,
      esConsumoTurno: false,
    };
  },
  computed: {
    totalCalculado() {
      if (
        !this.cantidad ||
        this.precioUnitario === null ||
        this.precioUnitario === undefined
      )
        return 0;
      const c = parseFloat(this.cantidad);
      const p = parseFloat(this.precioUnitario);
      if (isNaN(c) || isNaN(p)) return 0;
      return parseFloat((c * p).toFixed(2));
    },
    // Consumos sin grupo
    consumosSueltos() {
      return this.listaConsumos.filter((c) => !c.idGrupo);
    },
    // Grupos construidos desde los consumos que tienen idGrupo
    grupos() {
      const mapa = {};
      this.listaConsumos.forEach((c) => {
        if (!c.idGrupo) return;
        if (!mapa[c.idGrupo]) {
          mapa[c.idGrupo] = {
            idGrupo: c.idGrupo,
            nombreGrupo: c.nombreGrupo || `Grupo ${c.idGrupo}`,
            consumos: [],
            totalConsumido: 0,
            totalCobrado: 0,
            saldo: 0,
          };
        }
        mapa[c.idGrupo].consumos.push(c);
        mapa[c.idGrupo].totalConsumido += c.total || 0;
      });
      // Calcular cobrado y saldo por grupo
      Object.values(mapa).forEach((g) => {
        const cobros = this.cobrosGrupo[g.idGrupo] || [];
        g.totalCobrado = cobros
          .filter((cb) => cb.estado !== "Cancelado")
          .reduce((acc, cb) => acc + cb.total, 0);
        g.saldo = g.totalConsumido - g.totalCobrado;
      });
      return Object.values(mapa);
    },
    // Opciones para el selector de grupo en el formulario
    // Incluye grupos ya persistidos (con consumos) + grupos locales recién creados
    opcionesGrupo() {
      const persistidos = this.grupos.map((g) => ({
        idGrupo: g.idGrupo,
        nombre: g.nombreGrupo,
      }));
      const localesNuevos = this.gruposLocales.filter(
        (gl) => !persistidos.some((p) => p.idGrupo === gl.idGrupo),
      );
      return [...persistidos, ...localesNuevos];
    },
  },
  watch: {
    modoProducto: {
      immediate: true,
      handler(val) {
        if (val) {
          this.descripcion = "";
          this.total = null;
          if (!this.catalogoProductos.length) {
            this.cargarProductos();
          }
        } else {
          this.productoSeleccionado = null;
          this.cantidad = 1;
          this.precioUnitario = null;
        }
      },
    },
    productoSeleccionado(producto) {
      if (producto) {
        this.precioUnitario = producto.precioVenta;
      }
    },
    fechaLibre(newVal) {
      this.buscarConsumosTurno();
      // Al cambiar de fecha, limpiar grupos locales y selección
      this.gruposLocales = [];
      this.grupoSeleccionado = null;
      // Sincronizar la fecha del formulario de consumo con el día seleccionado
      if (newVal) {
        this.fechaConsumo = newVal;
      }
    },
  },
  methods: {
    editarConsumo(item) {
      this.editedItem.idConsumo = item.idConsumo;
      this.showEditarConsumo = true;
    },
    // ── Grupos ──────────────────────────────────────────────
    abrirNuevoGrupo() {
      this.nuevoNombreGrupo = "";
      this.showNuevoGrupo = true;
    },
    confirmarNuevoGrupo() {
      if (!this.nuevoNombreGrupo) return;
      const self = this;
      const fechaContexto =
        this.fechaLibre ||
        this.fechaConsumo ||
        new Date().toISOString().substr(0, 10);
      axios
        .post("/Caja/CrearGrupo", {
          nombreGrupo: this.nuevoNombreGrupo,
          fecha: fechaContexto,
          idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
          idTorneo: this.idTorneo > 0 ? this.idTorneo : null,
        })
        .then((response) => {
          const grupo = response.data;
          self.gruposLocales.push({
            idGrupo: grupo.idGrupo,
            nombre: grupo.nombreGrupo,
          });
          self.showNuevoGrupo = false;
          self.nuevoNombreGrupo = "";
          // Esperar a que Vue actualice el DOM antes de setear el valor seleccionado
          self.$nextTick(() => {
            self.grupoSeleccionado = grupo.idGrupo;
          });
        })
        .catch(() => {
          self.showAlert({
            icon: "warning",
            title: "No se pudo crear el grupo.",
            vm: self,
            timer: 2000,
          });
        });
    },
    async buscarCobrosGrupo(idGrupo) {
      try {
        const response = await axios.get("/Caja/BuscarCobrosGrupo", {
          params: { idGrupo },
        });
        this.$set(this.cobrosGrupo, idGrupo, response.data || []);
      } catch {
        this.$set(this.cobrosGrupo, idGrupo, []);
      }
    },
    cobrarGrupo(grupo) {
      // Emitir evento para que ConsumosWrapper abra NuevoCobro con idGrupo
      this.$emit("cobrarGrupo", {
        idGrupo: grupo.idGrupo,
        nombreGrupo: grupo.nombreGrupo,
        saldo: grupo.saldo,
      });
    },
    abrirEnviarCtaCteGrupo(grupo) {
      this.grupoParaCtaCte = grupo;
      this.showEnviarCtaCteGrupo = true;
    },
    cierraEnviarCtaCteGrupo() {
      this.showEnviarCtaCteGrupo = false;
      const grupo = this.grupoParaCtaCte;
      this.grupoParaCtaCte = null;
      this.buscarConsumosTurno();
      // Recargar cobros del grupo específico
      if (grupo) {
        this.$nextTick(() => this.buscarCobrosGrupo(grupo.idGrupo));
      }
    },
    borrarCobroGrupo(cobro, idGrupo) {
      this.$swal({
        title: "Borrar cobro",
        text: "¿Desea borrar el cobro del grupo?",
        icon: "warning",
        background: "#ececec",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
      }).then((result) => {
        if (!result.value) return;
        axios
          .get("/Caja/BorrarCobro", {
            params: { idCobro: cobro.idCobro, idTurno: 0 },
          })
          .then(() => {
            this.showAlert({
              icon: "success",
              title: "Cobro borrado.",
              vm: this,
              timer: 2000,
            });
            this.buscarCobrosGrupo(idGrupo);
            this.buscarConsumosTurno();
          })
          .catch(() => {
            this.showAlert({
              icon: "warning",
              title: "El cobro no pudo ser borrado.",
              vm: this,
            });
          });
      });
    },
    // ── Fin Grupos ───────────────────────────────────────────
    abrirEnviarCtaCteConsumo(item) {
      this.consumoParaCtaCte = item;
      this.showEnviarCtaCteConsumo = true;
    },
    cierraEnviarCtaCteConsumo() {
      this.showEnviarCtaCteConsumo = false;
      const consumo = this.consumoParaCtaCte;
      this.consumoParaCtaCte = null;
      this.buscarConsumosTurno();
      // Recargar cobros del consumo específico
      if (consumo) {
        this.$nextTick(() => this.buscarCobrosPorConsumo(consumo.idConsumo));
      }
    },
    precargarTurno() {
      // Activa modoProducto y pre-rellena con los datos del tipo de turno
      this.modoProducto = true;
      this.esConsumoTurno = true;
      this.$nextTick(() => {
        // Crear un objeto sintético que simula un producto del catálogo
        this.productoSeleccionado = {
          idProducto: null,
          nombre: this.tipoTurno.nombre,
          precioVenta: this.tipoTurno.total,
        };
        this.precioUnitario = this.tipoTurno.total;
        this.cantidad = 4;
      });
    },
    calcularTotalPagado(idConsumo) {
      const cobros = this.cobrosExpandidos[idConsumo] || [];
      return cobros
        .filter((c) => c.estado !== "Cancelado")
        .reduce((acc, c) => acc + c.total, 0);
    },
    calcularSaldo(consumo) {
      return consumo.total - this.calcularTotalPagado(consumo.idConsumo);
    },
    async buscarCobrosPorConsumo(idConsumo) {
      try {
        const response = await axios.get("/Caja/BuscarCobrosPorConsumo", {
          params: { idConsumo },
        });
        this.$set(this.cobrosExpandidos, idConsumo, response.data || []);
        // Actualizar totalPagado y saldo en la fila correspondiente
        const consumo = this.listaConsumos.find(
          (c) => c.idConsumo === idConsumo,
        );
        if (consumo) {
          const totalPagado = this.calcularTotalPagado(idConsumo);
          consumo.totalPagado = totalPagado;
          consumo.totalPagadoString = "$" + totalPagado.toFixed(2);
          const saldo = consumo.total - totalPagado;
          consumo.saldo = saldo;
          consumo.saldoString = "$" + saldo.toFixed(2);
        }
      } catch {
        this.$set(this.cobrosExpandidos, idConsumo, []);
      }
    },
    onRowExpanded(item) {
      this.buscarCobrosPorConsumo(item.idConsumo);
      this.$emit("seleccionarConsumo", {
        idConsumo: item.idConsumo,
        descripcion: item.descripcion,
      });
    },
    clickRow(item, event) {
      // Only allow row-click expand in torneo/libre context
      if (this.idTorneo <= 0 && this.fechaLibre == null) return;
      const index = this.expandedItems.findIndex(
        (i) => i.idConsumo === item.idConsumo
      );
      if (index > -1) {
        this.expandedItems.splice(index, 1);
      } else {
        this.expandedItems.push(item);
        this.onRowExpanded(item);
      }
    },
    agregarCobroDesdeDetalle(idConsumo) {
      const consumo = this.listaConsumos.find((c) => c.idConsumo === idConsumo);
      this.$emit("seleccionarConsumo", {
        idConsumo,
        descripcion: consumo?.descripcion || "",
      });
    },
    borrarCobroDetalle(cobro, idConsumo) {
      this.$swal({
        title: "Borrar cobro",
        text: "¿Desea borrar el cobro?",
        icon: "warning",
        background: "#ececec",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
      }).then((result) => {
        if (!result.value) return;
        axios
          .get("/Caja/BorrarCobro", {
            params: { idCobro: cobro.idCobro, idTurno: cobro.idTurno || 0 },
          })
          .then(() => {
            this.showAlert({
              icon: "success",
              title: "Cobro borrado.",
              vm: this,
              timer: 2000,
            });
            this.buscarCobrosPorConsumo(idConsumo);
            this.buscarConsumosTurno();
          })
          .catch(() => {
            this.showAlert({
              icon: "warning",
              title:
                "El cobro no puede ser borrado por estar incluído en un cierre de caja.",
              vm: this,
            });
          });
      });
    },
    cierraEditarConsumo() {
      if (this.idTurno > 0 || this.idInscripcion > 0) {
        this.buscarConsumosTurno();
      }
      this.showEditarConsumo = false;
    },
    toFixed() {
      if (isNaN(parseFloat(this.total)))
        this.total = parseFloat(0.0).toFixed(2);
      else this.total = parseFloat(this.total).toFixed(2);
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    vaciarModels() {
      this.descripcion = "";
      this.observaciones = "";
      this.total = "";
      // En contexto libre, mantener la fecha para poder cargar varios consumos seguidos
      if (this.fechaLibre == null) {
        this.fechaConsumo = moment().format("YYYY-MM-DD");
      }
      // Resetear modo producto
      this.modoProducto = true;
      this.productoSeleccionado = null;
      this.cantidad = 1;
      this.precioUnitario = null;
      this.errorCargaProductos = false;
      this.esConsumoTurno = false;
      // No limpiar grupoSeleccionado para poder cargar varios consumos al mismo grupo
    },
    async cargarProductos() {
      this.cargandoProductos = true;
      this.errorCargaProductos = false;
      try {
        const { data } = await axios.get("/Producto/GetProductos", {
          params: {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            estado: "Activo",
            nombre: "%",
            codigo: "%",
            idCategoria: 0,
          },
        });
        this.catalogoProductos = data || [];
      } catch {
        this.errorCargaProductos = true;
        this.catalogoProductos = [];
      } finally {
        this.cargandoProductos = false;
      }
    },
    toFixedPrecio() {
      if (isNaN(parseFloat(this.precioUnitario)))
        this.precioUnitario = parseFloat(0.0).toFixed(2);
      else this.precioUnitario = parseFloat(this.precioUnitario).toFixed(2);
    },
    guardarConsumo() {
      if (moment(this.fechaConsumo).isBefore(moment("1900-01-01"))) {
        showAlert({
          icon: "warning",
          title: "La fecha del consumo debe ser mayor o igual al 01/01/1900.",
          timer: 2500,
          vm: this,
        });
        return;
      }

      // Validar fecha futura solo para turno o caja libre (no inscripción/torneo)
      // Se compara la fecha del CONTEXTO (turno o caja libre), no la fecha del consumo
      const esContextoTurnoOLibre = this.idTurno > 0 || this.fechaLibre != null;
      let fechaContexto = null;
      if (this.fechaLibre != null) {
        fechaContexto = this.fechaLibre;
      } else if (this.fechaTurno) {
        // fechaTurno puede venir como DD/MM/YYYY o YYYY-MM-DD
        fechaContexto = this.fechaTurno.includes('/') 
          ? this.fechaTurno.split('/').reverse().join('-') 
          : this.fechaTurno;
      }
      const esFechaFutura = esContextoTurnoOLibre && fechaContexto && moment(fechaContexto).isAfter(moment().startOf('day'));

      const confirmarGuardado = () => {
        this.$swal({
          title: "Registrar consumo",
          text: "¿Desea registrar el consumo?",
          icon: "success",
          type: "success",
          showCancelButton: true,
          background: "#ececec",
          confirmButtonText: "Si",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
          const datosConsumo = {
            fecha: this.fechaConsumo,
            idTurno: this.idTurno,
            idInscripcion: this.idInscripcion,
            idTorneo: this.idTorneo,
            total: this.modoProducto ? this.totalCalculado : this.total,
            descripcion: this.modoProducto
              ? this.productoSeleccionado.nombre
              : this.descripcion,
            observaciones: this.observaciones,
            idProducto: this.modoProducto
              ? this.productoSeleccionado.idProducto
              : null,
            cantidad: this.modoProducto ? this.cantidad : null,
            usuario: this.$store.state.usuario.usuario,
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            idGrupo: this.grupoSeleccionado || null,
            nombreGrupo: this.grupoSeleccionado
              ? (
                  this.opcionesGrupo.find(
                    (g) => g.idGrupo === this.grupoSeleccionado,
                  ) || {}
                ).nombre || null
              : null,
            esConsumoTurno: this.esConsumoTurno,
          };
          let self = this;
          axios
            .post("/Caja/GuardarConsumo", datosConsumo)
            .then((response) => {
              self.$refs.form.resetValidation();
              self.vaciarModels();
              self.buscarConsumosTurno();
              document.getElementsByClassName(
                "v-dialog--active",
              )[0].scrollTop = 0;
              self.showAlert({
                icon: "success",
                title: "Consumo registrado.",
                vm: self,
                timer: 2000,
              });
              // Advertencia de stock bajo
              if (response.data && response.data.stockBajo) {
                self.showAlert({
                  icon: "warning",
                  title: `Stock bajo: el producto "${datosConsumo.descripcion}" alcanzó o superó el mínimo configurado.`,
                  vm: self,
                  timer: 4000,
                });
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "El consumo no pudo ser registrado.",
                vm: this,
                timer: 2000,
              });
            });
        }
      });
      };

      if (esFechaFutura) {
        this.$swal({
          title: "Fecha futura detectada",
          text: `Está cargando un consumo en un ${this.fechaLibre != null ? 'día de caja libre' : 'turno'} con fecha ${moment(fechaContexto).format('DD/MM/YYYY')}, que es posterior al día de hoy. ¿Desea continuar?`,
          icon: "warning",
          background: "#ececec",
          showCancelButton: true,
          confirmButtonText: "Sí, continuar",
          cancelButtonText: "Cancelar",
          showCloseButton: true,
        }).then((result) => {
          if (result.value) {
            confirmarGuardado();
          }
        });
      } else {
        confirmarGuardado();
      }
    },
    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
    buscarConsumosTurno() {
      // Evitar query sin filtros: si fechaLibre es null y los tres ids son 0, no ejecutar
      if (
        this.fechaLibre == null &&
        this.idTurno == 0 &&
        this.idInscripcion == 0 &&
        this.idTorneo == 0
      ) {
        return;
      }

      const params = {
        idTurno: this.idTurno,
        idInscripcion: this.idInscripcion,
        idTorneo: this.idTorneo,
      };

      if (this.fechaLibre != null) {
        params.fecha = this.fechaLibre;
      }

      let self = this;
      axios
        .get("/Caja/BuscarConsumosTurno?", {
          params,
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.listaConsumos = response.data;
          else self.listaConsumos = [];
        })
        .catch(function (error) {
          self.listaConsumos = [];
        })
        .finally(async () => {
          const total = self.listaConsumos.reduce(
            (acc, curr) => (acc = acc + curr.total),
            0,
          );

          // En contexto torneo y libre, cargar cobros de todos los consumos para calcular totales
          if (
            (self.idTorneo > 0 || self.fechaLibre != null) &&
            self.listaConsumos.length
          ) {
            await Promise.all(
              self.listaConsumos.map((consumo) =>
                self.buscarCobrosPorConsumo(consumo.idConsumo),
              ),
            );
            // Cargar cobros de grupos
            const idsGrupos = [
              ...new Set(
                self.listaConsumos
                  .filter((c) => c.idGrupo)
                  .map((c) => c.idGrupo),
              ),
            ];
            await Promise.all(
              idsGrupos.map((id) => self.buscarCobrosGrupo(id)),
            );
          }

          self.$emit("actualizarTotal", total);
        });
    },
    borrarConsumo(item) {
      this.$swal({
        title: "Borrar consumo",
        text: "¿Desea borrar el consumo?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          let self = this;
          axios
            .get("/Caja/BorrarConsumo?", {
              params: {
                idConsumo: item.idConsumo,
              },
            })
            .then((response) => {
              self.showAlert({
                icon: "success",
                title: "Consumo borrado.",
                vm: self,
                timer: 2000,
              });
              if (
                self.idTurno > 0 ||
                self.idInscripcion > 0 ||
                self.idTorneo > 0 ||
                self.fechaLibre
              ) {
                setTimeout(self.buscarConsumosTurno(), 1700);
              }
              self.$emit("consumoBorrado");
              this.delta = true;
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "El consumo no pudo ser borrado.",
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    exportarPDFNuevo() {
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const nombreInstitucion =
        this.$store.state.usuario.institucion.nombreInstitucion
          .toString()
          .trim();

      // ── Encabezado ──────────────────────────────────────────────────────────
      doc.setFontSize(12);
      doc.text(nombreInstitucion, 14, 15);
      doc.setFontSize(16);
      doc.text("Reporte de Consumos", pageWidth / 2, 25, { align: "center" });
      doc.setFontSize(10);
      let y = 35;
      doc.text(
        `Fecha de emisión: ${moment().format("DD/MM/YYYY HH:mm")}`,
        14,
        y,
      );
      y += 6;
      if (this.nombrePaciente) {
        doc.text(`Jugador: ${this.nombrePaciente}`, 14, y);
        y += 6;
      }

      const hayGrupos = this.grupos.length > 0;

      // ── Modo con grupos (torneo / libre con mesas) ───────────────────────────
      if (hayGrupos) {
        // Sección por cada grupo
        for (const grupo of this.grupos) {
          // Verificar espacio en página
          if (y > 240) {
            doc.addPage();
            y = 20;
          }

          // Título del grupo
          doc.setFontSize(13);
          doc.setFont(undefined, "bold");
          doc.setTextColor(33, 33, 33);
          doc.text(`Mesa / Grupo: ${grupo.nombreGrupo}`, 14, y);
          y += 6;

          // Consumos del grupo
          const consumosGrupoData = grupo.consumos.map((c, i) => [
            i + 1,
            c.fechaString,
            c.observaciones
              ? (c.descripcion || "-") + " - " + c.observaciones
              : c.descripcion || "-",
            c.totalString,
          ]);
          doc.autoTable({
            startY: y,
            head: [["N", "Fecha", "Descripción", "Importe"]],
            body: consumosGrupoData,
            theme: "grid",
            headStyles: {
              fillColor: [103, 58, 183],
              textColor: 255,
              fontStyle: "bold",
            },
            styles: { fontSize: 8 },
            columnStyles: {
              0: { cellWidth: 12, halign: "center" },
              1: { cellWidth: 28, halign: "center" },
              2: { cellWidth: 110 },
              3: { cellWidth: 30, halign: "right" },
            },
          });
          y = doc.lastAutoTable.finalY + 3;

          // Cobros del grupo
          const cobrosGrupoArr = this.cobrosGrupo[grupo.idGrupo] || [];
          if (cobrosGrupoArr.length) {
            doc.setFontSize(9);
            doc.setFont(undefined, "italic");
            doc.setTextColor(80, 80, 80);
            doc.text("Cobros del grupo:", 14, y + 4);
            y += 5;
            const cobrosGrupoData = cobrosGrupoArr.map((cb, i) => [
              i + 1,
              cb.fechaString,
              cb.nombreFormaPago || "-",
              cb.estado || "-",
              cb.totalString,
            ]);
            doc.autoTable({
              startY: y,
              head: [["N", "Fecha", "Forma Pago", "Estado", "Importe"]],
              body: cobrosGrupoData,
              theme: "grid",
              headStyles: {
                fillColor: [33, 150, 243],
                textColor: 255,
                fontStyle: "bold",
              },
              styles: { fontSize: 8 },
              columnStyles: {
                0: { cellWidth: 12, halign: "center" },
                1: { cellWidth: 28, halign: "center" },
                2: { cellWidth: 50 },
                3: { cellWidth: 40 },
                4: { cellWidth: 30, halign: "right" },
              },
            });
            y = doc.lastAutoTable.finalY + 3;
          }

          // Totales del grupo
          doc.setFontSize(9);
          doc.setFont(undefined, "bold");
          doc.setTextColor(0, 0, 0);
          doc.text(
            `Consumido: $${grupo.totalConsumido.toFixed(
              2,
            )}   Cobrado: $${grupo.totalCobrado.toFixed(
              2,
            )}   Saldo: $${grupo.saldo.toFixed(2)}`,
            pageWidth - 14,
            y + 4,
            { align: "right" },
          );
          y += 10;
          // Línea separadora
          doc.setDrawColor(200, 200, 200);
          doc.line(14, y, pageWidth - 14, y);
          y += 6;
        }

        // Sección consumos sueltos
        if (this.consumosSueltos.length > 0) {
          if (y > 230) {
            doc.addPage();
            y = 20;
          }
          doc.setFontSize(13);
          doc.setFont(undefined, "bold");
          doc.setTextColor(33, 33, 33);
          doc.text("Consumos sueltos", 14, y);
          y += 5;

          const sueltoData = this.consumosSueltos.map((c, i) => [
            i + 1,
            c.fechaString,
            c.observaciones
              ? (c.descripcion || "-") + " - " + c.observaciones
              : c.descripcion || "-",
            c.totalString,
            c.totalPagadoString || "$0.00",
            c.saldoString || c.totalString,
          ]);
          doc.autoTable({
            startY: y,
            head: [
              ["N", "Fecha", "Descripción", "Consumido", "Pagado", "Saldo"],
            ],
            body: sueltoData,
            theme: "grid",
            headStyles: {
              fillColor: [103, 58, 183],
              textColor: 255,
              fontStyle: "bold",
            },
            styles: { fontSize: 8 },
            columnStyles: {
              0: { cellWidth: 12, halign: "center" },
              1: { cellWidth: 25, halign: "center" },
              2: { cellWidth: 80 },
              3: { cellWidth: 25, halign: "right" },
              4: { cellWidth: 25, halign: "right" },
              5: { cellWidth: 25, halign: "right" },
            },
          });
          y = doc.lastAutoTable.finalY + 8;
        }

        // Totales globales
        const totalConsumido = this.listaConsumos.reduce(
          (acc, c) => acc + c.total,
          0,
        );
        const totalCobrado =
          this.grupos.reduce((acc, g) => acc + g.totalCobrado, 0) +
          this.consumosSueltos.reduce(
            (acc, c) => acc + (c.totalPagado || 0),
            0,
          );
        doc.setFontSize(11);
        doc.setFont(undefined, "bold");
        doc.setTextColor(0, 0, 0);
        doc.text(
          `Total consumido: $${totalConsumido.toFixed(2)}`,
          pageWidth - 14,
          y,
          { align: "right" },
        );
        y += 7;
        doc.text(
          `Total cobrado: $${totalCobrado.toFixed(2)}`,
          pageWidth - 14,
          y,
          { align: "right" },
        );
        y += 7;
        const saldoGlobal = totalConsumido - totalCobrado;
        doc.setTextColor(
          saldoGlobal > 0 ? 200 : 0,
          0,
          saldoGlobal > 0 ? 0 : 150,
        );
        doc.text(
          `Saldo pendiente: $${saldoGlobal.toFixed(2)}`,
          pageWidth - 14,
          y,
          { align: "right" },
        );
        doc.setTextColor(0, 0, 0);
      } else {
        // ── Modo sin grupos (turno / inscripción / libre sin mesas) ─────────────
        const tableData = this.listaConsumos.map((item, index) => [
          index + 1,
          item.fechaString,
          item.observaciones
            ? (item.descripcion || "-") + " - " + item.observaciones
            : item.descripcion || "-",
          item.totalString,
        ]);
        doc.autoTable({
          startY: y + 4,
          head: [["N", "Fecha", "Descripcion", "Importe"]],
          body: tableData,
          theme: "grid",
          headStyles: {
            fillColor: [103, 58, 183],
            textColor: 255,
            fontStyle: "bold",
          },
          styles: { fontSize: 9 },
          columnStyles: {
            0: { cellWidth: 15, halign: "center" },
            1: { cellWidth: 30, halign: "center" },
            2: { cellWidth: 100 },
            3: { cellWidth: 35, halign: "right" },
          },
        });

        const total = this.listaConsumos.reduce(
          (acc, curr) => acc + curr.total,
          0,
        );
        let finalY = doc.lastAutoTable.finalY + 8;

        doc.setFontSize(11);
        doc.setFont(undefined, "bold");
        doc.text(
          `Total consumido: $${total.toFixed(2)}`,
          pageWidth - 14,
          finalY,
          { align: "right" },
        );

        const cant = parseInt(this.cantJugadores) || 1;
        if (cant > 1) {
          finalY += 7;
          doc.text(
            `Total por jugador (${cant}): $${(total / cant).toFixed(2)}`,
            pageWidth - 14,
            finalY,
            { align: "right" },
          );
        }

        if (this.listaCobros && this.listaCobros.length > 0) {
          finalY += 12;
          doc.setFontSize(13);
          doc.setFont(undefined, "bold");
          doc.text("Cobros realizados", 14, finalY);

          const cobrosData = this.listaCobros.map((item, index) => [
            index + 1,
            item.fechaString,
            item.paciente || "-",
            item.nombreFormaPago || "-",
            item.estado || "-",
            item.totalString,
          ]);
          doc.autoTable({
            startY: finalY + 4,
            head: [
              ["N", "Fecha", "Concepto", "Forma Pago", "Estado", "Importe"],
            ],
            body: cobrosData,
            theme: "grid",
            headStyles: {
              fillColor: [33, 150, 243],
              textColor: 255,
              fontStyle: "bold",
            },
            styles: { fontSize: 9 },
            columnStyles: {
              0: { cellWidth: 12, halign: "center" },
              1: { cellWidth: 28, halign: "center" },
              2: { cellWidth: 55 },
              3: { cellWidth: 35 },
              4: { cellWidth: 30 },
              5: { cellWidth: 28, halign: "right" },
            },
          });

          const totalCobrado = this.listaCobros.reduce(
            (acc, curr) => acc + curr.total,
            0,
          );
          const saldoPendiente = total - totalCobrado;
          let cobFinalY = doc.lastAutoTable.finalY + 8;

          doc.setFontSize(11);
          doc.setFont(undefined, "bold");
          doc.text(
            `Total cobrado: $${totalCobrado.toFixed(2)}`,
            pageWidth - 14,
            cobFinalY,
            { align: "right" },
          );
          cobFinalY += 7;

          const saldoColor = saldoPendiente > 0 ? [200, 0, 0] : [0, 150, 0];
          doc.setTextColor(...saldoColor);
          doc.text(
            `Saldo pendiente: $${saldoPendiente.toFixed(2)}`,
            pageWidth - 14,
            cobFinalY,
            { align: "right" },
          );
          doc.setTextColor(0, 0, 0);
        }
      }

      window.open(doc.output("bloburl"), "_blank");
    },

    exportarPDFPorGrupo() {
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const nombreInstitucion =
        this.$store.state.usuario.institucion.nombreInstitucion
          .toString()
          .trim();

      let primeraHoja = true;

      for (const grupo of this.grupos) {
        if (!primeraHoja) doc.addPage();
        primeraHoja = false;

        // ── Encabezado de hoja ─────────────────────────────────────────────
        doc.setFontSize(11);
        doc.setFont(undefined, "normal");
        doc.setTextColor(100, 100, 100);
        doc.text(nombreInstitucion, 14, 12);

        doc.setFontSize(18);
        doc.setFont(undefined, "bold");
        doc.setTextColor(33, 33, 33);
        doc.text(grupo.nombreGrupo, pageWidth / 2, 24, { align: "center" });

        doc.setFontSize(9);
        doc.setFont(undefined, "normal");
        doc.setTextColor(100, 100, 100);
        const contexto = this.fechaLibre
          ? `Caja del día — ${this.fechaLibre}`
          : this.idTorneo > 0
          ? "Caja del Torneo"
          : "";
        if (contexto)
          doc.text(contexto, pageWidth / 2, 30, { align: "center" });
        doc.text(
          `Emitido: ${moment().format("DD/MM/YYYY HH:mm")}`,
          pageWidth - 14,
          30,
          { align: "right" },
        );

        // Línea separadora
        doc.setDrawColor(180, 180, 180);
        doc.line(14, 33, pageWidth - 14, 33);

        // ── Tabla de consumos ──────────────────────────────────────────────
        doc.setFontSize(10);
        doc.setFont(undefined, "bold");
        doc.setTextColor(33, 33, 33);
        doc.text("Consumos", 14, 40);

        const consumosData = grupo.consumos.map((c, i) => [
          i + 1,
          c.fechaString,
          c.descripcion || "-",
          c.totalString,
        ]);

        doc.autoTable({
          startY: 43,
          head: [["#", "Fecha", "Descripción", "Importe"]],
          body: consumosData,
          theme: "grid",
          headStyles: {
            fillColor: [103, 58, 183],
            textColor: 255,
            fontStyle: "bold",
          },
          styles: { fontSize: 9 },
          columnStyles: {
            0: { cellWidth: 12, halign: "center" },
            1: { cellWidth: 30, halign: "center" },
            2: { cellWidth: 120 },
            3: { cellWidth: 28, halign: "right" },
          },
        });

        let y = doc.lastAutoTable.finalY + 6;

        // ── Totales ────────────────────────────────────────────────────────
        doc.setFontSize(11);
        doc.setFont(undefined, "bold");
        doc.setTextColor(0, 0, 0);
        doc.text(
          `Total consumido: $${grupo.totalConsumido.toFixed(2)}`,
          pageWidth - 14,
          y,
          { align: "right" },
        );
        y += 7;
        doc.text(
          `Total cobrado: $${grupo.totalCobrado.toFixed(2)}`,
          pageWidth - 14,
          y,
          { align: "right" },
        );
        y += 7;
        const saldo = grupo.saldo;
        doc.setTextColor(saldo > 0 ? 200 : 0, 0, saldo > 0 ? 0 : 150);
        doc.text(`Saldo pendiente: $${saldo.toFixed(2)}`, pageWidth - 14, y, {
          align: "right",
        });
        doc.setTextColor(0, 0, 0);
      }

      window.open(doc.output("bloburl"), "_blank");
    },
  },
  created() {
    this.fechaConsumo = this.fechaLibre || moment().format("YYYY-MM-DD");
    this.buscarConsumosTurno();
  },
};
</script>

<style scoped>
.expanded-detail-cell {
  background-color: #e8eaf6 !important; /* indigo lighten-5 */
}

.expanded-detail-container {
  border-left: 4px solid #3f51b5; /* indigo */
}

.expanded-detail-header {
  padding: 6px 12px;
  background-color: #c5cae9; /* indigo lighten-3 */
  display: flex;
  align-items: center;
}

.cobros-detalle-table {
  background-color: transparent !important;
}

.cobros-detalle-table :deep(thead tr th) {
  background-color: #e8eaf6 !important;
  color: #283593 !important;
  font-size: 0.75rem;
}

.cobros-detalle-table :deep(tbody tr:hover) {
  background-color: #c5cae9 !important;
}
</style>
